import { Link } from "react-router-dom";
import { useSeo } from "~/lib/seo/useSeo";
import { ASSUNTOS } from "~/lib/ia/assuntos";
import { CAPA, CAPA_SIZES, CAPA_SRCSET } from "~/lib/videos";
import { EntreNaLista } from "~/ui/EntreNaLista";

/**
 * O índice dos assuntos: o destino do link na bio, e a porta de entrada de
 * quem chega pela busca em um assunto e descobre que tem mais.
 */
export function IAHub() {
  useSeo({
    title: "Inteligência artificial explicada",
    description:
      "Cada vídeo do @bittarg vira uma página escrita, com as fontes que foram conferidas. O que é LLM, RAG, agente, alucinação, data center e o resto.",
    pathname: "/ia",
  });

  return (
    <main className="jg-shell py-16 sm:py-24">
      <div className="max-w-[58ch]">
        <p className="jg-eyebrow">Assuntos</p>
        <h1 className="jg-display mt-3 text-4xl sm:text-5xl">
          Inteligência artificial explicada por escrito.
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-jg-fg-muted">
          Cada vídeo vira uma página aqui, com as fontes que eu conferi antes
          de gravar. Dá para ler sem assistir, e dá para checar tudo que eu
          afirmei.
        </p>
      </div>

      <ul className="jg-grid mt-14 gap-y-10 sm:mt-20">
        {ASSUNTOS.map((a) => (
          <li key={a.slug} className="col-span-full lg:col-span-6">
            <Link className="jg-assunto" to={`/ia/${a.slug}`}>
              <img
                className="jg-assunto-capa"
                src={CAPA(a.slug)}
                srcSet={CAPA_SRCSET(a.slug)}
                sizes={CAPA_SIZES}
                width={272}
                height={484}
                loading="lazy"
                decoding="async"
                alt=""
              />
              <span>
                <span className="jg-assunto-titulo">{a.titulo}</span>
                <span className="mt-2 block text-sm leading-relaxed text-jg-fg-muted">
                  {a.resumo}
                </span>
                <span className="mt-3 block text-xs uppercase tracking-[0.08em] text-jg-fg-muted">
                  {a.fontes.length}{" "}
                  {a.fontes.length === 1 ? "fonte" : "fontes"}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <section className="jg-grid mt-24 sm:mt-32">
        <span className="jg-fio col-span-full" />
        <div className="col-span-full pt-9 lg:col-span-6">
          <h2 className="font-display text-[length:var(--text-step-2)] font-medium leading-tight tracking-[-0.015em]">
            Receba o próximo por e-mail
          </h2>
          <p className="mt-6 max-w-[46ch] leading-relaxed text-jg-fg-muted">
            Toda semana um assunto novo, com a explicação escrita e as fontes.
          </p>
        </div>
        <div className="col-span-full mt-10 lg:col-span-5 lg:col-start-8 lg:mt-1 lg:pt-9">
          <EntreNaLista origem="ia-hub" />
        </div>
      </section>
    </main>
  );
}
